module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bMe49"))).then(() => parcelRequire('5erN3'));